import React, { useState } from 'react'
import { Button, Col, Row, Image, Space } from 'antd'
import educations from 'data/educations.json'

const ExpandedData = ({ data }) => {

    const { course = {} } = data

    const [isImageVisible, setIsImageVisible] = useState(false)
    const [selectedImage, setSelectedImage] = useState("")

    const handleImageClick = (image) => { setSelectedImage(image); setIsImageVisible(true) }

    const tableData = [
        { heading: "Registration Number", data: data.registrationNumber },
        { heading: "Country", data: data.country.name },
        { heading: "Province", data: data.province.name },
        { heading: "City", data: data.city.name },
        { heading: "CNIC/B-Form", data: data.cnic },
        { heading: "Email", data: data.email },
        { heading: "Full Name", data: data.fullName },
        { heading: "First Name", data: data.firstName },
        { heading: "Last Name", data: data.lastName },
        { heading: "Gender", data: data.gender, className: "text-capitalize" },
        { heading: "Date of Birth", data: window.dateFormat(data.dob, "DD-MMM-YYYY") },
        { heading: "Age", data: data.age },
        { heading: "Education", data: educations.find(education => education.value === data.education)?.label },
        { heading: "Father Name", data: data.fatherName },
        { heading: "Father CNIC", data: data.fatherCNIC },
        { heading: "Phone", data: <a href={`tel:+${data.phone}`} target="_blank" rel="noopener noreferrer">{data.phone}</a> },
        { heading: "WhatsApp", data: <a href={`https://wa.me/${data.whatsapp}`} target="_blank" rel="noopener noreferrer">{data.whatsapp}</a> },
        { heading: "Blood Group", data: window.toCapitalizeCase(data.bloodGroup) },
        { heading: "Religion", data: window.toCapitalizeCase(data.religion) },
        { heading: "Address", data: data.address },
        { heading: "Date Created", data: window.dateFormat(data.createdAt, "dddd DD-MMM-YYYY, hh:mm:ss A") },
        { heading: "Created By", data: data.createdBy },
        { heading: "Photo", data: <Button type='link' className='p-0 h-auto' onClick={() => { handleImageClick(data.photoURL) }}>Click to See</Button> },
    ]

    const courseDetails = [
        { heading: "Course ID", data: data.courseId },
        { heading: "Type", data: course.type },
        { heading: "Title", data: course.title },
        { heading: "Batch", data: course.batch },
        { heading: "Abbreviation", data: course.abbreviation },
        { heading: "Learning Type", data: course.learningType, className: "text-capitalize" },
        { heading: "Session", data: course.session },
        { heading: "Status", data: data.status, className: "text-capitalize" },
        { heading: "Payment", data: data.payment, className: "text-capitalize" },
        { heading: "Result", data: data.result, className: "text-capitalize" },
        { heading: "Result Remarks", data: data.resultRemarks},
    ]

    const tableComponent = (heading, array) => {
        return <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover align-middle mb-0">
                <tbody>
                    <tr><th colSpan={2} className='text-center'>{heading}</th></tr>
                    {array.map((row, i) => {
                        return <tr key={i}>
                            <th style={{ minWidth: 180 }}>{row.heading}</th>
                            <td className={row.className || ""}>{row.data}</td>
                        </tr>
                    })}
                </tbody>
            </table>
        </div>
    }

    return (
        <>
            <Row>
                <Col xs={24} lg={{ span: 14, offset: 5 }}>
                    <Space direction="vertical" size="large" className='w-100'>
                        {tableComponent("Student Details", tableData)}
                        {tableComponent("Course Details", courseDetails)}
                    </Space>
                </Col>
            </Row>

            <Image preview={{ visible: isImageVisible, src: selectedImage, onVisibleChange: (value) => { setIsImageVisible(value) } }} />
        </>
    )
}

export default ExpandedData